import { connect } from 'react-redux'
import UniversalMenuConfigModal from '@components/groupOrders/UniversalMenuConfigModal'
import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { RestService, ChefService, UIService, SettingsService } = services
  const {
    AsyncLoadDietaryAllergens,
    AddItemToBlacklist,
    AddVendorToBlacklist,
    LoadChefs,
    LoadSettings,
    RetryOnTimeout,
    SearchMenuItems,
    UpdateItemBlacklistEntry,
    UpdateVendorBlacklistEntry,
  } = coordinators
  const { pMapOptionAttributes } = presenters
  const {
    pResponseChefs,
    pResponseIndexMenuItems,
    pRequestSettings,
    pResponseSettings,
  } = presenters.Api
  const loadChefs = LoadChefs({ ChefService, RestService, pResponseChefs })

  // Item
  const addItemToBlacklist = AddItemToBlacklist({
    RestService,
    HandleError,
  })
  const updateItemBlacklistEntry = UpdateItemBlacklistEntry({
    RestService,
    HandleError,
  })

  // Vendor
  const addVendorToBlacklist = AddVendorToBlacklist({
    RestService,
    HandleError,
  })
  const updateVendorBlacklistEntry = UpdateVendorBlacklistEntry({
    RestService,
    HandleError,
  })

  const loadMenuItems = SearchMenuItems({
    RestService,
    pResponseMenuItemsSearch: pResponseIndexMenuItems,
  })

  const loadAllergens = AsyncLoadDietaryAllergens({
    RestService,
    SettingsService,
    pMapOptionAttributes,
    pRequestSettings,
    pResponseSettings,
    LoadSettings,
    RetryOnTimeout,
    HandleError,
  })

  const { FlashMessage, InfoModal } = UIService
  const { displayInfoModal, dismissInfoModal } = InfoModal
  const { displayFailureMessage } = FlashMessage

  return {
    addItemToBlacklist,
    addVendorToBlacklist,
    dismissInfoModal,
    displayFailureMessage,
    showCustomModal: displayInfoModal,
    loadAllergens,
    loadChefs,
    loadMenuItems,
    updateItemBlacklistEntry,
    updateVendorBlacklistEntry,
  }
}

export default connect(undefined, mapDispatchToProps)(UniversalMenuConfigModal)
